<template>
  <div class="d-flex gap-2 w-100" :class="{ 'flex-column': !flex }">
    <div :class="flex ? 'w-50' : 'w-100'">
      <label for="name">{{ $i18n.t('component_name') }}</label>
      <el-input id="name" class="p-editor" data-id="cc-name" v-model="componentName" :disabled="!isCreate" />
      <code-editor
        lang='text/x-vue'
        :disableSyntaxCheck='true'
        v-if="ready"
        :emit-on-change='true'
        :code='template'
        :id='id'
        @code-change="valueChange($event.value)"
      />
      <div class="p-editor">
        <el-button @click="onSave" data-id="cc-save" :disabled="hasError" type="primary">
          {{ $i18n.t('save_template') }}
        </el-button>
        <el-button @click="swapView" data-id="cc-swap-view" type="success">
          <span class="angled material-icons md-12">swap_horiz</span>{{ $i18n.t('swap_view') }}
        </el-button>
      </div>
    </div>
    <div class="preview-container p-editor" :class="flex ? 'w-50' : 'w-100'">
      <custom-component-loader
        :is-preview="true"
        :preview-component="renderTemplate"
        :component-name="componentName"
        @component-error="onErrorChange"
      />
    </div>
  </div>
</template>

<script>
import CustomComponentLoader from './CustomComponentLoader.vue'
import CodeEditor from '../code-editor/CodeEditor.vue'
import { debounce, get } from 'lodash'

export default {
  name: 'CustomComponentEditor',
  components: {
    CustomComponentLoader,
    CodeEditor,
  },
  data() {
    return {
      ready: false,
      componentName: '',
      template: '',
      renderTemplate: '',
      hasError: false,
      flex: true,
    }
  },
  computed: {
    id(){
      const mongoId = get(this.$route, 'query.mongoId')
      return `custom-component-editor-${mongoId}`
    },
    isCreate() {
      return !!this.$route.path.match(/\/create$/) // @regex ha a string vege /create
    },
    isValid() {
      return this.editorErrors.valid
    },
  },
  methods: {
    onErrorChange(hasError) {
      this.hasError = hasError
    },
    onPreview: debounce(function () {
      this.renderTemplate = `${this.template}`
    }, 1500),
    async onSave() {
      const parameters = {
        data: {
          componentName: this.componentName,
          vueContent: this.template,
        },
      }
      if (!this.isCreate) {
        parameters.id = get(this.$route, 'query.mongoId')
      }
      this.$client
        .execute({
          operationId: 'CustomComponents_saveComponent',
          parameters,
        })
        .then(({ body }) => {
          if (body.id) {
            if (this.isCreate && body.id) {
              location.href = `update?mongoId=${body.id}`
            }
            this.$notify({
              title: 'saved_successfully',
              text: '',
              type: 'success',
            })
          }
        })
        .catch((error) => {
          this.$notify({
            title: 'save_failed',
            text: error,
            type: 'error',
          })
        })
    },
    swapView() {
      this.flex = !this.flex
    },
    valueChange(value) {
      this.template = value
      this.onPreview()
    },
  },
  async created() {
    if (this.isCreate) {
      this.ready = true
      return
    }
    this.$client
      .execute({
        operationId: 'CustomComponents_findById',
        parameters: {
          mongoId: get(this.$route, 'query.mongoId'),
        },
      })
      .then(({ body }) => {
        this.componentName = body.componentName
        this.template = body.vueContent
        this.ready = true
        this.onPreview()
      })
  },
}
</script>

<style scoped lang="scss">
label {
  padding-inline-start: 10px;
}
.angled.material-icons {
  transform: rotate(315deg);
  padding-inline-end: 5px;
}
.preview-container {
  border: 2px dashed $border-color;
  border-radius: $border-radius;
}
.p-editor {
  padding: 10px;
}
</style>
